import { useMutation } from '@tanstack/react-query';
import { errorHandler } from '@app/utils/errorHandler';
import { PANEl_BASE_URL } from '@app/contstants/endpoints';
import { api } from '@app/utils/api';
import { TeamYearlyPlanDto, TeamYearlyPlanRequest } from '../types';

export const updateTeamYearlyPlan = async (
  data: TeamYearlyPlanRequest
): Promise<TeamYearlyPlanDto> => {
  const response = await api.post<TeamYearlyPlanDto>(
    `${PANEl_BASE_URL}/general/team-year-plan/create_by_params/`,
    data
  );

  return response.data;
};

export const useUpdateTeamYearlyPlan = () => {
  const { mutateAsync, isError, isPending, isSuccess, error } = useMutation({
    mutationFn: updateTeamYearlyPlan,
    onError: error => errorHandler(error),
  });

  return {
    updateTeamYearlyPlan: mutateAsync,
    isError,
    isPending,
    isSuccess,
    error,
  };
};
